import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { environment } from 'src/environments/environment';
import { catchError, of } from 'rxjs';

interface CustomFont {
  _id?: string;
  id?: string;

  name: string;
  originalName: string;
  url?: string; // URL for the loaded font
  family?: string; // Font family name for CSS
  isLoading?: boolean; // Track loading state
}

@Injectable({
  providedIn: 'root'
})

export class FontService {
  private loadedFonts = new Set<string>();

  constructor(private apiService:ApiService ){}
  
  // loadFont(fontName: string, fontPath: string, fontFormat: string = 'woff2') {
  //   if (this.loadedFonts.has(fontName)) {
  //     return;
  //   }
    
  //   const style = document.createElement('style');
  //   style.textContent = `
  //     @font-face {
  //       font-family: '${fontName}';
  //       src: url('${fontPath}') format('${fontFormat}');
  //       font-weight: normal;
  //       font-style: normal;
  //     }
  //   `;
  //   document.head.appendChild(style);
  //   this.loadedFonts.add(fontName);
  // }
  /**
   * Load a custom font using the CSS Font Loading API
   * @param fontName The name of the font to load
   * @param fontUrl The URL to the font file
   * @returns Promise that resolves when the font is loaded
   */
  loadFont(fontName: string, fontUrl: string): Promise<void> {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return Promise.resolve();
    }
    // Check if already loaded to prevent duplicates
    if (this.loadedFonts.has(fontName)) {
      return Promise.resolve();
    }
    
    return new Promise<void>((resolve, reject) => {
      try {
        // Create a new style element
        const style = document.createElement('style');
        style.innerHTML = `
          @font-face {
            font-family: '${fontName}';
            src: url('${fontUrl}') format('${this.getFontFormat(fontUrl)}');
            font-weight: normal;
            font-style: normal;
            font-display: swap;
          }
        `;
        
        // Append the style to the document head
        document.head.appendChild(style);
        
        // Use the CSS Font Loading API if available
        if ('FontFace' in window) {
          const font = new FontFace(fontName, `url(${fontUrl})`);
          
          font.load()
            .then((loadedFont) => {
              // Add the font to the document fonts
              (document.fonts as any).add(loadedFont);
              this.loadedFonts.add(fontName);
              resolve();
            })
            .catch((error) => {
              console.warn(`FontFace API failed to load ${fontName}:`, error);
              // Still consider it loaded (the CSS @font-face will still work)
              this.loadedFonts.add(fontName);
              resolve();
            });
        } else {
          // Fallback for browsers without FontFace API
          this.loadedFonts.add(fontName);
          resolve();
        }
      } catch (error) {
        console.error(`Error in loadFont for ${fontName}:`, error);
        reject(error);
      }
    });
  }
  
  /**
   * Determine font format based on file extension
   */
  private getFontFormat(url: string): string {
    const extension = url.split('.').pop()?.toLowerCase() || '';
    
    switch (extension) {
      case 'woff2': return 'woff2';
      case 'woff': return 'woff';
      case 'ttf': return 'truetype';
      case 'otf': return 'opentype';
      case 'eot': return 'embedded-opentype';
      case 'svg': return 'svg';
      default: return 'woff2'; // Default to woff2
    }
  }
  
  /**
   * Check if a font is already loaded
   */
  isFontLoaded(fontName: string): boolean {
    return this.loadedFonts.has(fontName);
  }
  
  /**
   * Get the list of all loaded fonts
   */
  getLoadedFonts(): string[] {
    return Array.from(this.loadedFonts);
  }
  loadFontUrl(fontName: string, fontUrl: string, fontFormat: string = 'woff2') {
    if (typeof document === 'undefined' || this.loadedFonts.has(fontName)) {
      return;
    }
    
    const style = document.createElement('style');
    style.textContent = `
      @font-face {
        font-family: '${fontName}';
        src: url('${fontUrl}') format('${fontFormat}');
        font-weight: normal;
        font-style: normal;
      }
    `;
    document.head.appendChild(style);
    this.loadedFonts.add(fontName);
  }

//   // Load the actual font data and create CSS
//  loadFontData(font: CustomFont): void {
//   console.log(" DATA loadFloadFontDataloadFontDataloadFontDataloadFontDataloadFontDataontData");
//   console.log("loadFontData", font);

//   // Use _id if id is not available
//   const fontId = font.id || font._id;
//   console.log("Using font ID:", fontId);

//   this.apiService.getBlob(environment.BASEURL + environment.FONT_GET_APIURL + `/${fontId}`)
//     .pipe(
//       catchError(error => {
//         console.error(`Error loading font data for ${font.name}:`, error);
//         return of(null);
//       })
//     )
//     .subscribe(blob => {
//       if (blob) {
//         // Create a blob URL for the font
//         const fontUrl = URL.createObjectURL(blob);
//         font.url = fontUrl;
        
//         // Add font-face to document
//         this.addFontFace(font);
        
//         // Mark as loaded in next cycle
//         setTimeout(() => {
//           font.isLoading = false;
//         });
//       }
//     });
// }
}
